module.exports = __webpack_public_path__ + "assets/img/Deauville_007.3acdc92e.jpg";